import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    label: string;
    intercomDisabled: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Button label */
            label: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ContactSupportMenuItem.label?c=35oj9lyumr8a6", defaultMessage: "Contact Support" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Warning toast title shown when the in-app support messenger (Intercom) is unavailable */
            intercomDisabled: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ContactSupportMenuItem.intercomDisabled?c=1iyaopx12qu40", defaultMessage: "Intercom is probably disabled in Segment for this environment." }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
